<template>
  <div>
    <!-- 表格上方搜索框 -->
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-form-item label="日期段">
        <a-range-picker
          ref="myData1"
          v-decorator="[
            'dateRange',
            {
              rules: [
                {
                  required: true,
                  message: '请选择日期段!'
                }
              ],
              initialValue: defaultDateValue
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="门店">
        <a-select
          style="width: 200px"
          ref="mySelect1"
          v-decorator="[
            'dateSelect',
            {
              initialValue: defaultStringValue
            }
          ]"
        >
          <a-select-option
            v-for="(item, index) in selectData"
            :key="index"
            :value="item.Id"
            >{{ item.Text }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="门店名称">
        <a-input
          ref="myInput1"
          v-decorator="[
            'KeyWord',
            {
              initialValue: defaultStringValue
            }
          ]"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" :loading="searchLoading">
          查询
        </a-button>
      </a-form-item>
    </a-form>
    <a-table
      class="forcast-table"
      :columns="columns"
      :dataSource="data"
      :pagination="pagination"
      :loading="tableLoading"
      bordered
      size="small"
      :scroll="scrollArray"
      style="margin-top:20px;"
    >
    </a-table>
    <!-- 表格部分 -->
    <div style="backgroundColor:white;height:52px">
      <!-- 分页器部分 -->
      <a-pagination
        @change="onChange"
        :current="currentPage"
        :total="totalPage"
        style="margin:20px;float:right;"
        :pageSize="7"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { cache } from "@/utils/common";
moment.locale("zh-cn");

const renderContent = (value, row) => {
  const obj = {
    children: value,
    attrs: {}
  };
  if (row.title) {
    obj.attrs.colSpan = 0;
  }
  return obj;
};

export default {
  name: "RoomoreForcast",
  data() {
    return {
      //表格主体部分变量
      data: [],
      columns: [],
      pagination: false,
      tableLoading: false,
      scrollArray: { x: 450, y: 900 },

      //搜索框部分变量
      form: this.$form.createForm(this),
      defaultStringValue: "",
      defaultDateValue: [],
      searchLoading: false,

      //搜索框门店下拉数据源
      selectData: [],
      //默认固定行数，4为总计、出租、房费、平均的总数
      mergeNumber: 4,
      //记录每个集团的总计行的行数，用于计算每个集团占多少行，动态生成行数
      mainRow: 0,

      //表格分页器变量
      currentPage: 1,
      totalPage: 0
    };
  },
  created() {
    const _this = this;

    //设置搜索框的初始日期值
    var nowDate = cache.get("user").AccountDate;
    var afterDay = _this.GetDateStr(nowDate, 14);
    _this.defaultDateValue = [
      moment(nowDate, "YYYY-MM-DD"),
      moment(afterDay, "YYYY-MM-DD")
    ];

    //根据初始日期值初始化表格
    _this.$post("GetGroupSelectItems", { Types: "company" }).then(res => {
      _this.selectData = res.Data.company;
      let item = {
        StartDate: nowDate,
        EndDate: afterDay,
        PageIndex: 0,
        PageSize: 7
      };
      this.init(item);
    });
  },
  methods: {
    //分页器切换页码后初始化表格
    onChange(current) {
      const _this = this;
      _this.currentPage = current;
      let item = {
        StartDate: moment(this.$refs.myData1.value[0]).format("YYYY-MM-DD"),
        EndDate: moment(this.$refs.myData1.value[1]).format("YYYY-MM-DD"),
        CompanyId: this.$refs.mySelect1.value,
        KeyWord: this.$refs.myInput1.value,
        PageIndex: current - 1,
        PageSize: 7
      };
      _this.init(item);
    },
    //根据传入数据初始化表格
    init(postData) {
      const _this = this;

      //初始化变量，滚动数组内的值为固定表头的宽和高，剩余数值动态加
      _this.mainRow = 0;
      _this.scrollArray.y = 75;
      _this.scrollArray.x = 450;

      _this.$post("GroupPredictAsync_List", postData).then(res => {
        _this.searchLoading = false;
        _this.totalPage = res.Data.Total;
        // _this.currentPage = 1;

        //无数据时，弹出警告并返回
        if (res.Data.Details == "") {
          this.$message.error("无数据");
          return;
        }

        var itemCompanyData = res.Data.Datas;
        var itemCheckIn = [];

        //遍历数据源，将数据整理后装填人itemCheckIn，作为新的表格数据
        for (let l = 0; l < itemCompanyData.length; l++) {
          //新增自定义行
          var ratArray = { title: "出租率" };
          var priceArray = { title: "房费预测" };
          var balancePriceArray = { title: "平均房价" };

          var item = itemCompanyData[l].Details;

          //将日期与数据项内数据重新拼合，例如CheckIn10-22
          for (let m = 0; m < item.length; m++) {
            ratArray["CheckIn" + item[m].Date] = item[m].RentRate;
            priceArray["CheckIn" + item[m].Date] = item[m].PredictRoomPrice;
            balancePriceArray["CheckIn" + item[m].Date] = item[m].AvgRoomPrice;
            for (let n in item[m]) {
              itemCompanyData[l][n + item[m].Date] = item[m][n];
            }
          }
          itemCompanyData[l].RoomTypeName = "总计";
          itemCompanyData[l].State = "展开详情";

          //将整理好的行数据填入数据源
          itemCheckIn.push(itemCompanyData[l]); //总计行
          itemCheckIn.push(ratArray); //出租行
          itemCheckIn.push(priceArray); //价格行
          itemCheckIn.push(balancePriceArray); //平均行
        }

        //遍历新的数据源，计算出表格的新高度，用于滚动
        for (let k = 0; k < itemCheckIn.length; k++) {
          _this.scrollArray.y += 38;
        }

        if (itemCompanyData != "") {
          var dateForm = itemCompanyData[0].Details;
          //设置表格结构
          _this.columns = [
            {
              title: "门店",
              dataIndex: "CompanyName",
              align: "center",
              width: 250,
              fixed: "left",
              customRender: (value, row, index) => {
                if (row.RoomTypeName == "总计") {
                  _this.mainRow = index;

                  const onClick = {
                    click: () => {
                      this.reviewGroupTable(row);
                    }
                  };

                  //获取详细数据的行数
                  var addNumber = 0;
                  if (row.moreDetail) {
                    addNumber = row.moreDetail.length;
                  }

                  return {
                    //为详情/收起详情按钮设置功能
                    children: (
                      <div>
                        <p>{value}</p>
                        <a href="javascript:;" {...{ on: onClick }}>
                          {row.State}
                        </a>
                      </div>
                    ),
                    //动态合并单个集团行数
                    attrs: { rowSpan: _this.mergeNumber + addNumber }
                  };
                } else {
                  //被合并的行数需要将行数为0，不然会出现表格错乱
                  return {
                    attrs: { rowSpan: 0 }
                  };
                }
              }
            },
            {
              title: "房型",
              dataIndex: "RoomTypeName",
              align: "center",
              width: 150,
              fixed: "left",
              customRender: (value, row, index) => {
                var addNumber = 0;
                if (row.moreDetail) {
                  addNumber = row.moreDetail.length;
                }
                //如果存在title属性则横向合并2格
                if (row.title) {
                  return {
                    children: row.title,
                    attrs: { colSpan: 2 }
                  };
                } else if (
                  index < _this.mainRow + _this.mergeNumber + addNumber &&
                  index > _this.mainRow
                ) {
                  //被合并的格子需设置为0，不然会出现表格错乱
                  return {
                    attrs: { rowSpan: 0 }
                  };
                } else {
                  return {
                    children: value
                  };
                }
              }
            },
            {
              title: "总数",
              dataIndex: "Quantity",
              align: "center",
              fixed: "left",
              width: 50,
              customRender: renderContent
            }
          ];
          for (let i = 0; i < dateForm.length; i++) {
            _this.scrollArray.x += 250;
            let item = {
              title: dateForm[i].Date + "  " + dateForm[i].Week,
              customRender: (value, row, index) => {
                if (index == 0 || (index + 1) % 4 == 0) {
                  return {
                    children: value
                  };
                } else {
                  return {
                    children: row.title
                  };
                }
              },
              children: [
                {
                  title: "在住",
                  dataIndex: "CheckIn" + dateForm[i].Date,
                  align: "center",
                  width: 50,
                  customRender: (value, row) => {
                    if (row.title) {
                      return {
                        children: value,
                        attrs: { colSpan: 5 }
                      };
                    } else {
                      return {
                        children: value
                      };
                    }
                  }
                },
                {
                  title: "预订",
                  dataIndex: "Booking" + dateForm[i].Date,
                  align: "center",
                  width: 50,
                  customRender: renderContent
                },
                {
                  title: "可卖",
                  dataIndex: "Saleable" + dateForm[i].Date,
                  align: "center",
                  width: 50,
                  customRender: renderContent
                },
                {
                  title: "维修",
                  dataIndex: "Repair" + dateForm[i].Date,
                  align: "center",
                  width: 50,
                  customRender: renderContent
                },
                {
                  title: "预离",
                  dataIndex: "Leaving" + dateForm[i].Date,
                  align: "center",
                  width: 50,
                  customRender: renderContent
                }
              ]
            };
            _this.columns.push(item);
          }
        }
        _this.data = itemCheckIn;
      });
    },
    handleSubmit(e) {
      var _this = this;
      e.preventDefault();
      _this.form.validateFields((err, values) => {
        if (!err) {
          _this.searchLoading = true;
          let item = {
            StartDate: moment(values.dateRange[0]).format("YYYY-MM-DD"),
            EndDate: moment(values.dateRange[1]).format("YYYY-MM-DD"),
            CompanyId: values.dateSelect,
            KeyWord: values.KeyWord,
            PageIndex: 0,
            PageSize: 7
          };
          _this.init(item);
        }
      });
    },
    //获取输入日期几天后的日期
    GetDateStr(inputDayCount, AddDayCount) {
      var dd = new Date(inputDayCount);
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      return y + "-" + m + "-" + d;
    },

    //用于展开和收缩单个集团门店表，输入数据为当前点击集团门店的单条数据
    reviewGroupTable(companyData) {
      var _this = this;
      var tableData = _this.data;
      if (companyData.State == "展开详情") {
        var itemCompanyDetail = {
          CompanyId: companyData.Id,
          StartDate: moment(this.$refs.myData1.value[0]).format("YYYY-MM-DD"),
          EndDate: moment(this.$refs.myData1.value[1]).format("YYYY-MM-DD")
        };
        _this.$post("CompanyRoomStatus_Get", itemCompanyDetail).then(res => {
          if (res.Data.Details != "") {
            var itemSave = [];
            var addPositon = 0;
            for (let i = 0; i < tableData.length; i++) {
              if (companyData.Id == tableData[i].Id) {
                addPositon = i;
                tableData[i].moreDetail = res.Data.Details;
                tableData[i].State = "收起详情";
                var itemDetail = tableData[i].moreDetail;
                for (let l = 0; l < itemDetail.length; l++) {
                  var itemRow = {};
                  itemRow.Add = companyData.CompanyName;
                  itemRow.RoomTypeName = itemDetail[l].RoomTypeName;
                  itemRow.Quantity = itemDetail[l].Quantity;
                  for (
                    let m = 0;
                    m < itemDetail[l].PredictCalendars.length;
                    m++
                  ) {
                    for (let n in itemDetail[l].PredictCalendars[m]) {
                      itemRow[n + itemDetail[l].PredictCalendars[m].Date] =
                        itemDetail[l].PredictCalendars[m][n];
                    }
                  }
                  itemSave.push(itemRow);
                }
              }
            }
            for (let j = 0; j < itemSave.length; j++) {
              tableData.splice(addPositon + 4 + j, 0, itemSave[j]);
              _this.scrollArray.y += 38;
            }
          } else {
            this.$message.info("暂无详情数据");
            return;
          }
        });
      } else if (companyData.State == "收起详情") {
        var itemArray = [];
        for (let i = 0; i < tableData.length; i++) {
          if (
            !tableData[i].Add &&
            tableData[i].Add == companyData.CompanyName
          ) {
            if (
              tableData[i].RoomTypeName == "总计" &&
              tableData[i].CompanyName == companyData.CompanyName
            ) {
              tableData[i].State = "展开详情";
              delete tableData[i].moreDetail;
            }
            itemArray.push(tableData[i]);
          }
        }
        tableData = itemArray;
      }
      _this.data = tableData;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-table td {
  white-space: nowrap;
}
.forcast-table /deep/.ant-table-thead {
  tr {
    th {
      background: rgb(16, 150, 184) !important;
      color: #fff;
    }
    &:first-child {
      th:nth-child(2) {
        font-size: 16px;
      }
    }
  }
}
</style>
